import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { CheckoutReviewAndSubmitPageContext } from "@insite/content-library/Pages/CheckoutReviewAndSubmitPage";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import { CustomState } from "@preferredMedical/Store/CustomState";
import { CustomActions } from "@preferredMedical/Store/Reducers";
import React, { ChangeEvent, Component, useEffect, useState } from "react";
import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: CustomState) => {
    const { cartId } = state.pages.checkoutReviewAndSubmit;
    const cart = cartId ? getCartState(state, cartId).value : getCurrentCartState(state).value;
    return {
        notes: cart?.notes,
    };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<CustomState, any, CustomActions>) => {
    return {
        setNotes: (notes: string) => dispatch({ type: "Custom/Pages/CheckoutReviewAndSubmit/SetNotes", notes }),
    };
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps> & TextAreaProps;

export interface CheckoutReviewAndSubmitOrderNotesEntryStyles {
    textArea?: TextAreaProps;
}

export const checkoutReviewAndSubmitOrderNotesEntryStyles: CheckoutReviewAndSubmitOrderNotesEntryStyles = {
    textArea: {
        css: css`
            min-width: 100%;
            max-width: 100%;
            min-height: 50px;
        `,
    },
};

const styles = checkoutReviewAndSubmitOrderNotesEntryStyles;

const CheckoutReviewAndSubmitOrderNotesEntry = ({ notes, setNotes }: Props) => {
    const [notesState, setNotesState] = useState(notes);

    const notesChangeHandler = (event: ChangeEvent<HTMLTextAreaElement>) => {
        setNotes(event.currentTarget.value);
        setNotesState(event.currentTarget.value);
    };

    if (notes === undefined) {
        return null;
    }

    return (
        <TextArea
            {...styles.textArea}
            maxLength={255}
            label={translate("Add Delivery Instructions and Order Notes")}
            placeholder={translate("You can start typing here")}
            value={notesState}
            onChange={notesChangeHandler}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CheckoutReviewAndSubmitOrderNotesEntry),
    definition: {
        group: "Checkout - Review & Submit",
        displayName: "Order Notes Entry",
        allowedContexts: [CheckoutReviewAndSubmitPageContext],
    },
};

export default widgetModule;
